<template>
  <div
    class="flex flex-wrap gap-16"
    :class="{
      'flex-row items-center': uspDirection === 'row',
      'flex-col': uspDirection !== 'row',
    }"
  >
    <div
      v-for="(item, idx) in items"
      :key="idx"
      class="flex flex-row gap-8"
      :class="{
        'items-start': item.SubLabel,
        'items-center': !item.SubLabel,
        'md:mb-16': uspDirection !== 'row',
      }"
    >
      <nuxt-icon
        class="text-24 md:text-[3.2rem] text-text-primary"
        :name="item.Icon"
        :filled="isColoredIcon(item.Icon)"
        aria-hidden="true"
      />
      <div class="flex flex-col items-start">
        <p class="heading-xxs" v-html="item.Label"></p>
        <p v-if="item.SubLabel" v-html="item.SubLabel"></p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { UspItem } from '~/models/UspItem.model';

interface Props {
  uspDirection: string;
  items?: UspItem[];
}

defineProps<Props>();

const isColoredIcon = (icon: string): boolean => {
  switch (icon) {
    case 'alert-circle-red':
    case 'alert-circle-orange':
    case 'alert-circle-blue':
    case 'check-circle-green':
    case 'check-circle-white':
      return true;
    default:
      return false;
  }
};
</script>

<style scoped></style>
